import { Box, Button, Modal, TextField, Typography } from "@mui/material";
import React from "react";

function WelcomeModal2({openModal2, handleCloseModal2, style, emailForUpdates, e, setEmailForUpdates, keyPressEmail, handleSignUpForUpdates}) {
    return (<Modal open={openModal2} onClose={handleCloseModal2} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
    <Box sx={style}>
      <Typography variant="h6" component="h2">
        Sign up for our email list ✨
      </Typography>
      {
    /* <Typography sx={{ mt: 2 }}>
      So be sure to never miss out on the latest features, improvements, and word wonders within our app! 📚
    </Typography> */
  }
      <Typography sx={{
    mt: 2
  }}>
      Join us on our journey of bringing you amazing features, improvements, and word wonders! 📚
  
  We're growing and getting better every day. Don't miss out! 🚀        </Typography>
    
      <Box sx={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    mt: 2
  }}>
        <TextField type="text" value={emailForUpdates} onChange={e => setEmailForUpdates(e.target.value)} placeholder="Enter your email" sx={{
      mb: 2,
      width: '100%'
    }} onKeyDown={keyPressEmail} InputProps={{
      classes: {
        input: 'placeholder-italic'
      }
    }} InputLabelProps={{
      classes: {
        root: 'input-label'
      }
    }} />
  
        <Button onClick={handleSignUpForUpdates} variant="contained" sx={{
      width: '100%',
      maxWidth: '180px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: '#7E57C2'
    }}>
          <b>Join the list! </b>
          <span style={{
        marginLeft: '4px'
      }}>💌</span>
        </Button>
  
        <Button variant="outlined" onClick={handleCloseModal2} sx={{
      mt: 2
    }}>
          Close
        </Button>
      </Box>
  
    </Box>
  </Modal>);
  }

  export default WelcomeModal2;